// product list
export const OWNER_PUT_REQUEST = 'OWNER_PUT_REQUEST';
export const OWNER_PUT_SUCCESS = 'OWNER_PUT_SUCCESS';
export const OWNER_PUT_ERROR = 'OWNER_PUT_ERROR'; 

